import { type Dispatch, type RefObject, type SetStateAction, useEffect, useRef } from 'react';

/*
The AllOddsLink container width changes as the link text is now coming from translations,
which effects where the bets wrapper sits.
This code adjusts the horizontal alignment of the GroupTitle labels wrapper to
maintain alignment over the bets wrapper.
*/

export const useAlignLabelsWithBets = ({
  seeAllOddsContainerRef,
  setGroupTitleLabelsMarginRight,
}: {
  seeAllOddsContainerRef: RefObject<HTMLDivElement | null>;
  setGroupTitleLabelsMarginRight: Dispatch<SetStateAction<number>>;
}) => {
  const marginHasBeenSet = useRef(false);
  const seeAllOddsContainerMarginLeft = 15;

  useEffect(() => {
    const shouldSetGroupTitleLabelsMarginRight = seeAllOddsContainerRef.current && !marginHasBeenSet.current;

    if (shouldSetGroupTitleLabelsMarginRight) {
      const seeAllOddsContainerWidth =
        (seeAllOddsContainerRef?.current?.offsetWidth ?? 0) + seeAllOddsContainerMarginLeft;

      setGroupTitleLabelsMarginRight(seeAllOddsContainerWidth);

      marginHasBeenSet.current = true;
    }
  }, [seeAllOddsContainerRef, setGroupTitleLabelsMarginRight]);
};
